import React from 'react';

import OtherSecurityDisplay from './OtherSecurityDisplay';
import Explanation from './Explanation';
import DigitNotice from './DigitNotice';

export default () => (
  <div>
    <Explanation>
      The <DigitNotice>3 digits</DigitNotice> on the <em>back</em> of your credit card.
    </Explanation>
    <OtherSecurityDisplay />
  </div>
);
